import { render, staticRenderFns } from "./le-upload-img-wx.vue?vue&type=template&id=19fa543c&scoped=true&"
import script from "./le-upload-img-wx.vue?vue&type=script&lang=js&"
export * from "./le-upload-img-wx.vue?vue&type=script&lang=js&"
import style0 from "./le-upload-img-wx.vue?vue&type=style&index=0&id=19fa543c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa543c",
  null
  
)

export default component.exports